<!-- *ngIf="!removeFooter()" -->
<!-- <footer class="footer">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-sm-11 col-11 mx-auto">
				<div class="desb pb-0">
					<p class="text-center">READY TO TRANSFORM YOUR BRAND? <br> GET IN TOUCH WITH US TODAY.</p>


				</div>
				<nav class="footer-nav desb">
					<div class="position-absolute start-50 translate-middle">
						<p>
							<a href="/contact" class="cstbtn cstbtn128 ftr1"> <span class="text text128"> Let’s Talk</span> <span
									class="borderspan"><i class="fa fa-chevron-right" aria-hidden="true"></i>
								</span> </a>
						</p>
					</div>
					<div class="d-flex justify-content-between align-items-center footer-block">
						<div class="d-flex1 ">
							<img src="{{baseUrl}}/img/logos/pixtar-main-logo.svg" alt="Branding agency in Dubai " width="160" class="logo1">
							<p>Pixtar Branding Services LLC.</p>
							<p>Dubai, United Arab Emirates</p>

						</div>
						<div class="d-flex2">
							<ul class="mb-0">
								<li><a href="/services">Services</a></li>
								<li><a href="/studio">Studio</a></li>
								<li><a href="/projects">Projects</a></li>
								<li><a href="/process">Process</a></li>
								<li><a href="/blog">Blogs</a></li>
								<li>
									<p>
										<a href="/contact" class="cstbtn cstbtn128 ftr2"> <span class="text text128"> Ask for a
												Quote</span>
											<span class="borderspan"><i class="fa fa-chevron-right opacity-0" aria-hidden="true"></i>
											</span>
										</a>
									</p>
								</li>
							</ul>
						</div>
					</div>
				</nav>
			</div>
			<div class="credits ml-auto">
				<span class="copyright">
					© {{test | date: 'yyyy'}}, All Rights Reserved Pixtar
				</span>
			</div>
		</div>
	</div>
</footer> -->
<!-- Remove the container if you want to extend the Footer to full width. -->
<div class="container my-5">
	<footer class="footer text-center text-lg-start">
		<!-- start -->
		<!-- <div class="container">
			<div class="row">
				<div class="col-md-12 col-sm-11 col-11 mx-auto">
					<div class="desb pb-0">
						<p class="text-center">READY TO TRANSFORM YOUR BRAND? <br> GET IN TOUCH WITH US TODAY.</p>


					</div>
					<nav class="footer-nav desb">
						<div class="position-absolute start-50 translate-middle">
							<p>
								<a href="/contact" class="cstbtn cstbtn128 ftr1"> <span class="text text128"> Let’s Talk</span> <span
										class="borderspan"><i class="fa fa-chevron-right" aria-hidden="true"></i>
									</span> </a>
							</p>
						</div>

					</nav>
				</div>

			</div>
		</div> -->
		<!-- end -->

		<!-- Grid container -->
		<div class="container p-4">
			<!--Grid row-->
			<div class="row my-4">
				<div class="col-md-12 col-sm-11 col-11 mx-auto">
					<div class="desb pb-0">
						<p class="text-center">
							READY TO TRANSFORM YOUR BRAND? <br />
							GET IN TOUCH WITH US TODAY.
						</p>
					</div>
					<div class="linkToPackages">
						<a
							type="button"
							href="/contact"
							class="d-flex justify-content-start align-items-center"
						>
							<span class="text semibold text-capitalize">Let’s Talk</span>
							<!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
							<lucide-icon
								name="chevron-right"
								class="lucide-arrow-icon"
							></lucide-icon>
							<span class="borderspan"> </span>
						</a>
					</div>
					<!-- <nav class="footer-nav desb">
						<div class="position-absolute start-50 translate-middle">
							<p>
								<a href="/contact" class="cstbtn cstbtn128 ftr1">
									<span class="text text128"> Let’s Talk</span>
									<span class="borderspan">
										<i class="fa fa-chevron-right" aria-hidden="true"></i>
										<lucide-icon
											name="chevron-right"
											class="lucide-arrow-icon"
										></lucide-icon>
									</span>
								</a>
							</p>
						</div>
					</nav> -->
				</div>
				<!--Grid column-->
				<div class="col-lg-3 col-md-12 mb-2 mt-4 mb-md-4">
					<div class="footer-block">
						<div class="d-flex1">
							<!-- <img src="https://mdbootstrap.com/img/Photos/new-templates/animal-shelter/logo.png" height="70" alt="rebranding agency dubai"
							loading="lazy" /> -->
							<img
								src="{{ baseUrl }}/img/logos/pixtar-main-logo.webp"
								alt="Creative agency Dubai"
								width="160"
								height="50"
								class="logo1"
								loading="lazy"
							/>
							<p>Pixtar Branding Services LLC.</p>
							<p>Dubai, United Arab Emirates</p>
						</div>
					</div>
				</div>

				<!--Grid column-->

				<!--Grid column-->
				<div class="col-lg-2 col-sm-4 mb-2 mb-md-0 mt-md-4">
					<!-- <h5 class="text-uppercase mb-4">Animals</h5> -->

					<ul class="list-unstyled footer-block">
						<li class="mb-2">
							<a href="/services/branding" class="textcolor2">Branding</a>
						</li>
						<li class="mb-2">
							<a href="/services/graphics" class="textcolor2">Graphic Design</a>
						</li>
						<li class="mb-2">
							<a href="/services/website-development" class="textcolor2"
								>Website Services</a
							>
						</li>
						<li class="mb-2">
							<a href="/services/ecommerce-web-development" class="textcolor2"
								>eCommerce Solutions</a
							>
						</li>
					</ul>
				</div>
				<!--Grid column-->

				<!--Grid column-->
				<div class="col-lg-2 col-sm-4 mb-2 mb-md-0 mt-md-4">
					<!-- <h5 class="text-uppercase mb-4">Animals</h5> -->

					<ul class="list-unstyled footer-block block2">
						<li class="mb-2">
							<a href="/studio" class="textcolor2">Studio</a>
						</li>
						<li class="mb-2">
							<a href="/projects" class="textcolor2">Projects</a>
						</li>
						<li class="mb-2">
							<a href="/process" class="textcolor2">Process</a>
						</li>
						<li class="mb-2">
							<a href="/blog" class="textcolor2">Blogs</a>
						</li>
					</ul>
				</div>
				<!--Grid column-->

				<!--Grid column-->
				<div class="col-lg-2 col-sm-4 mb-2 mb-md-0 mt-md-4">
					<!-- <h5 class="text-uppercase mb-4">Contact</h5> -->
					<ul class="list-unstyled footer-block">
						<li class="mb-2">
							<a href="/privacy-policy" class="textcolor2">Privacy Policy</a>
						</li>
						<li class="mb-2">
							<a href="/terms-and-conditions" class="textcolor2"
								>Terms & Conditions</a
							>
						</li>
						<li class="mb-2">
							<a href="/contact" class="textcolor2">Contact Us</a>
						</li>
					</ul>
				</div>
				<!--Grid column-->

				<!--Grid column-->
				<div class="col-lg-3 col-md-12 mb-2 mb-md-0 mt-md-4">
					<!-- <div class="d-flex justify-content-between align-items-center footer-block">
						<div class="d-flex w-100 justify-content-center">
							<div class="detail w-100 d-none d-sm-block">
								<ul class="d-flex flex-row justify-content-center align-items-center flex-wrap pl-0 mb-0">
									<li>
										<input type="button" class="button" value="Client Login">
									</li>
									<li>
										<p>
											<a href="/contact" class="">
												<span class="text ">Ask for a Quote</span>
												<span class="borderspan">
													<i class="fa fa-chevron-right opacity-0" aria-hidden="true"></i>
												</span>
											</a>
										</p>
									</li>
								</ul>
							</div>
						</div>
					</div> -->

					<div class="detail d-flex2">
						<ul class="list-unstyled footer-block ftr-blk mb-0">
							<li class="mb-2">
								<a href="https://client.pixtar.ae/" target="_blank">
									<input
										type="button"
										class="button textcolor2 semibold"
										value="Client Login"
									/>
								</a>
							</li>
							<li class="mb-2">
								<!-- <p class=" ">
									<a href="/contact" class="cstbtn">
										<span class="cstbtnftr"> Ask for a Quote </span>
										<span class="borderspan">
											<i class="fa fa-chevron-right" aria-hidden="true"></i>
										</span>
									</a>
								</p> -->

								<div class="linkToPackages m-0">
									<a
										type="button"
										href="/contact"
										class="d-flex justify-content-start align-items-center"
									>
										<span class="text semibold text-capitalize"
											>Ask for a Quote</span
										>
										<!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
										<lucide-icon
											name="chevron-right"
											class="lucide-arrow-icon"
										></lucide-icon>
										<span class="borderspan sizesmall"> </span>
									</a>
								</div>
							</li>
						</ul>
					</div>

					<!-- <div class="col-lg-3 col-md-12 mb-2 mb-md-4">
						<div class="d-flex justify-content-between align-items-center footer-block">
							<div class="d-flex1 detail">
								<ul class="list-unstyled footer-block">
									<li class="mb-2">
										<input type="button" class="button" value="Client Login">
									</li>
									<li class="mb-2">
										<p class=" ">
											<a href="/contact" class="cstbtn ">
												<span class="cstbtnftr"> Ask for a Quote </span>
												<span class="borderspan">
													<i class="fa fa-chevron-right" aria-hidden="true"></i>
												</span>
											</a>
										</p>
									</li>
								</ul>
							</div>
						</div>
					</div> -->
				</div>
				<!--Grid column-->
			</div>
			<!--Grid row-->
		</div>
		<!-- Grid container -->

		<!-- Copyright -->
		<!-- <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
			© 2020 Copyright:
			<a class="" href="https://mdbootstrap.com/">MDBootstrap.com</a>
		</div> -->
		<div class="credits ml-auto">
			<span class="copyright textcolor2">
				© {{ test | date : "yyyy" }}, All Rights Reserved Pixtar
			</span>
		</div>
		<!-- Copyright -->
	</footer>
</div>
<!-- End of .container -->
<!-- *ngIf="removeFooter()" -->
<!-- <footer  class="footer footerBlk">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-11 m-auto">
				<div class="desb">
				<p class="text-center">Describe your project</p>
				<div class="describe d-flex flex-row justify-content-center">
				</div>
			</div>
			<nav class="footer-nav">

				<div class="d-flex justify-content-between align-items-start footer-block">
					<div class="d-flex1 ">
						<p>Pixtar Branding Services LLC.</p>
						<p>Dubai, United Arab Emirates</p>
						<p>+971527930781</p>
						<p class="mt-2"><a class="me-2" href="https://www.instagram.com/pixtar.ae/" target="_blank"><img src="{{baseUrl}}/images/instagram-white.svg" alt="web designing agency dubai" width="30"></a> <a class="me-2" href="https://www.linkedin.com/company/pixtar-ae/" target="_blank"><img src="{{baseUrl}}/images/linkedin-white.svg" alt="Top branding agency in Dubai" width="30"></a>
							<a class="whatsapp-icon2 slideUpReturn tabmob" href="https://wa.me/+971527930781" target="_blank">
								<img src="{{baseUrl}}/img/home/whatsapp-white.svg" alt="website development company dubai" />
							</a>
						</p>
					</div>
					<div class="d-flex2">
						<ul class="mb-0">
							<li><a routerLink="/projects">Projects</a></li>
							<li><a routerLink="/process">Process</a></li>
							<li><a routerLink="/about">About</a></li>
							<li><a href="/blog" target="_blank">Blogs</a></li>
							<li><a href="/contact">Contact</a></li>
						</ul>
					</div>
					<div class="social-links">
						<ul class="mb-0">
							<li class="opacity-0">

								<a href="#"><img src="{{baseUrl}}/img/home/facebook-white.svg" alt="best design agency" width="48" height="48"> </a>
								<a href="#"><img src="{{baseUrl}}/img/home/instagram-white.svg" alt="Top creative agencies in dubai" width="48" height="48"> </a>
								<a href="#"><img src="{{baseUrl}}/img/home/twitter-white.svg" alt="web development company dubai" width="48" height="48"> </a>
								<a href="#"><img src="{{baseUrl}}/img/home/linkedin-white.svg" alt="graphic design company" width="48" height="48"> </a>
							</li>
						</ul>
					</div>
				</div>

			</nav>
		</div>
			<div class="credits ml-auto">
				<span class="copyright">
					© {{test | date: 'yyyy'}}, All Rights Reserved Pixtar

				</span>
			</div>
		</div>
	</div>
</footer> -->
<!-- <a class="whatsapp-icon slideUpReturn tabmob" href="https://wa.me/+971527930781" target="_blank">
	<img src="{{baseUrl}}/img/home/whatsapp.svg" alt="Best Web Designers in Dubai" />
</a> -->
<!-- <section class="footer">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-sm-11 col-11 mx-auto">
				<div class="desb pb-0">
					<p class="text-center">READY TO TRANSFORM YOUR BRAND? <br> GET IN TOUCH WITH US TODAY.</p>
				</div>
			</div>
			<nav class="footer-nav desb">
				<div class="position-absolute start-50 translate-middle">
					<p>
						<a href="/contact" class="cstbtn cstbtn128 ftr1"> <span class="text text128"> Let’s Talk</span> <span
								class="borderspan"><i class="fa fa-chevron-right" aria-hidden="true"></i>
							</span> </a>
					</p>
				</div>
			</nav>
			<div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
				<div class="d-flex1 ">
					<img src="{{baseUrl}}/img/logos/pixtar-main-logo.svg" alt="Design and web development agency" width="160" class="logo1">
					<p>Pixtar Branding Services LLC.</p>
					<p>Dubai, United Arab Emirates</p>

				</div>
			</div>

			<div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
				<ul class="d-flex2 custom-ul1">
					<li><a href="/branding">Branding</a></li>
					<li><a href="/graphics">Graphics Design</a></li>
					<li><a href="/website">Website Service</a></li>
					<li><a href="/ecommerce">eCommerce Solutions</a></li>
				</ul>
			</div>


			<div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
				<ul class="custom-ul1">
					<li><a href="/studio">Studio</a></li>
					<li><a href="/projects">Projects</a></li>
					<li><a href="/process">Process</a></li>
					<li><a href="/blogs">Blogs</a></li>
				</ul>
			</div>


			<div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
				<ul class="custom-ul1">
					<li><a href="/privacy-policy">Privacy Policy </a></li>
					<li><a href="/terms-conditions">Terms Conditions </a></li>
					<li><a href="/contact">Contact </a></li>
				</ul>
			</div>

			<div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
				<ul class="footer-social-links">
					<li><a href="https://www.instagram.com/dnourdubai/" class="footer-social-insta" target="_blank"></a></li>
					<li><a href="https://www.facebook.com/dnourdubai/" class="footer-social-fb" target="_blank"></a></li>
					<li><a href="https://www.youtube.com/channel/UC6N_SJwJXHf_Ng4UUSNO2Ww" class="footer-social-yt"
							target="_blank"></a></li>
					<li><a href="https://www.pinterest.com/dnourdubai/" class="footer-social-pinterest" target="_blank"></a></li>
					<li><a href="https://www.linkedin.com/company/dnour/" class="footer-social-linkedin" target="_blank"></a></li>
					<li><a href="https://www.youtube.com/@dnourdubai/featured" class="footer-social-youtube" target="_blank"></a>
					</li>
				</ul>


			</div>

		</div>
		<div class="credits ml-auto">
			<span class="copyright">
				© {{test | date: 'yyyy'}}, All Rights Reserved Pixtar
			</span>
		</div>
	</div>
</section> -->
